const states = [
  { "name": "Jammu and Kashmir", "gst_code": "01" },
  { "name": "Himachal Pradesh", "gst_code": "02" },
  { "name": "Punjab", "gst_code": "03" },
  { "name": "Chandigarh", "gst_code": "04" },
  { "name": "Uttarakhand", "gst_code": "05" },
  { "name": "Haryana", "gst_code": "06" },
  { "name": "Delhi", "gst_code": "07" },
  { "name": "Rajasthan", "gst_code": "08" },
  { "name": "Uttar Pradesh", "gst_code": "09" },
  { "name": "Bihar", "gst_code": "10" },
  { "name": "Sikkim", "gst_code": "11" },
  { "name": "Arunachal Pradesh", "gst_code": "12" },
  { "name": "Nagaland", "gst_code": "13" },
  { "name": "Manipur", "gst_code": "14" },
  { "name": "Mizoram", "gst_code": "15" },
  { "name": "Tripura", "gst_code": "16" },
  { "name": "Meghalaya", "gst_code": "17" },
  { "name": "Assam", "gst_code": "18" },
  { "name": "West Bengal", "gst_code": "19" },
  { "name": "Jharkhand", "gst_code": "20" },
  { "name": "Odisha", "gst_code": "21" },
  { "name": "Chhattisgarh", "gst_code": "22" },
  { "name": "Madhya Pradesh", "gst_code": "23" },
  { "name": "Gujarat", "gst_code": "24" },
  { "name": "Dadra and Nagar Haveli and Daman and Diu", "gst_code": "26" },
  { "name": "Maharashtra", "gst_code": "27" },
  { "name": "Karnataka", "gst_code": "29" },
  { "name": "Goa", "gst_code": "30" },
  { "name": "Lakshadweep", "gst_code": "31" },
  { "name": "Kerala", "gst_code": "32" },
  { "name": "Tamil Nadu", "gst_code": "33" },
  { "name": "Puducherry", "gst_code": "34" },
  { "name": "Andaman and Nicobar Islands", "gst_code": "35" },
  { "name": "Telangana", "gst_code": "36" },
  { "name": "Andhra Pradesh", "gst_code": "37" },
  { "name": "Ladakh", "gst_code": "38" }
];

export default states;
